/** @jsxImportSource @emotion/react */

import styled from "@emotion/styled";
import DeleteIcon from "@material-ui/icons/Delete";
import Water from "./Water";
import { Fragment } from "react";


import { SIZES } from "../../constants";
import t from "../../translations";

const ProcessingOveraly = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #0005;
`;

const ErrorOverlay = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  line-height: 1.1;
  text-align: center;
  padding: 5px;
  color: rgb(238, 42, 42);
  background: #000c;
`;

const DeleteButton = styled(DeleteIcon)`
  position: absolute;
  bottom: 5px;
  right: 3px;
  color: #ddd;
  opacity: 0;
  height: 21px;
  width: 21px;
  background: #333;
  border-radius: 50%;
  padding: 2px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  :hover {
    transform: scale(1.1);
    opacity: 1 !important;
  }
`;

const PrintplateUpload = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  color: white;
  font-size: 25px;
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.7);
`;

const ThumbWrapper = styled.div`
  overflow: hidden;
  position: relative;
  cursor: pointer;
  :hover .delete {
    opacity: 0.6;
  }
`;

export const pixelToMm = pixels => {
  //FIXME: make DPI dynamic depends on backend
  //mm = pixels / (DPI * mmInInch)
  const mmInInch = 1 / 25.4;
  return Math.round(pixels / (100 * mmInInch));
};

const Thumb = props => {
  const { file, progress, onClick, onDelete } = props;

const imageWrappperWidth =
  window.innerWidth < 480 ? window.innerWidth / 2 - 14 : SIZES.leftBarOpened / 2 - 47;
  const height =
    file.imageSize.height * (imageWrappperWidth / file.imageSize.width);

  let overlays = [];
  if (!file.image || !file.image.hash) {
    overlays.push(<Water progress={progress} height={height} opacity={0.7} />);
    if (progress === 1 && !file.error) {
      overlays.push(<ProcessingOveraly>{t.processing}...</ProcessingOveraly>);
    }
    if (progress === 1 && file.error) {
      overlays.push(<ErrorOverlay>{file.error}</ErrorOverlay>);
    }
  } else {
    if (file.image.attachmentType === "printplate") {
      overlays.push(
        <PrintplateUpload>
          {pixelToMm(file.imageSize.width).toFixed(0)}x
          {pixelToMm(file.imageSize.height).toFixed(0)}
        </PrintplateUpload>
      );
    }
    overlays.push(
      <DeleteButton
        onClick={e => {
          onDelete(file);
          e.stopPropagation();
        }}
        className="delete"
      />
    );
  }

  const handleDragStart = e => {
    e.dataTransfer.setData("text/plain", JSON.stringify(file.image));
  };

  return (
    <ThumbWrapper
      onDragStart={handleDragStart}
      onClick={e => {
        onClick(file);
      }}
    >
      <img src={file.preview} className="preview" alt="preview" />
      {overlays.map((overlay, index) => {
        return <Fragment key={index}>{overlay}</Fragment>;
      })}
    </ThumbWrapper>
  );
};

export default Thumb;
